import { List } from 'immutable';
import BaseList from 'records/BaseList';

import {
  CUSTOM_INGREDIENT_ASYNC_ACTION_START,
  CUSTOM_INGREDIENT_ASYNC_ACTION_ERROR,
  CUSTOM_INGREDIENT_ASYNC_ACTION_SUCCESS,
  CUSTOM_INGREDIENT_RESET_STATE,
} from 'actions/customIngredient';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [CUSTOM_INGREDIENT_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CUSTOM_INGREDIENT_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CUSTOM_INGREDIENT_ASYNC_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [CUSTOM_INGREDIENT_RESET_STATE]: () => {
    return initialState;
  },
};

export default function customIngredient(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
